import React, { useState } from "react";
import styles from "./Input.module.scss";
import { EyeOpenIcon, EyeSlashIcon, InfoIcon } from "../../../assets/icons";

interface InputProps {
	label?: string;
	type?: "text" | "password" | "email" | "number";
	placeholder?: string;
	value?: string;
	onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
	error?: string;
	warning?: string;
	disabled?: boolean;
	loading?: boolean;
	loadingText?: string;
	name?: string;
	id?: string;
}

const Input = ({
	label,
	type = "text",
	placeholder,
	value,
	onChange,
	error,
	warning,
	disabled,
	loading,
	loadingText = "Please wait...",
	name,
	id,
}: InputProps) => {
	const [showPassword, setShowPassword] = useState(false);

	const isPassword = type === "password";
	const inputType = isPassword ? (showPassword ? "text" : "password") : type;

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		if (onChange) {
			onChange(e)
		}
	}

	const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
		if (!isPassword && onChange) {
			const trimmed = e.target.value.trim();
			if (trimmed !== e.target.value) {
				e.target.value = trimmed;
				onChange(e as unknown as React.ChangeEvent<HTMLInputElement>);
			}
		}
	}

	return (
		<div className={styles.wrapper}>
			{label && (
				<label className={styles.label} htmlFor={id ?? name}>
					{label}
				</label>
			)}
			<div className={`${styles.inputWrapper} ${error ? styles.hasError : ""} ${warning ? styles.hasWarning : ""} ${disabled || loading ? styles.disabled : ""}`}>
				{loading ? (
					<div className={styles.loadingContent}>
						<span className={styles.loadingSpinner} />
						<span className={styles.loadingText}>{loadingText}</span>
					</div>
				) : (
					<>
				<input
					id={id ?? name}
					name={name}
					type={inputType}
					placeholder={placeholder}
					value={value}
					onChange={handleChange}
					onBlur={handleBlur}
					disabled={disabled}
					className={styles.input}
				/>
				{isPassword && (
					<button
						type="button"
						className={styles.eyeButton}
						onClick={() => setShowPassword(prev => !prev)}
						tabIndex={-1}
					>
						{showPassword ? <EyeOpenIcon /> : <EyeSlashIcon />}
					</button>
				)}
					</>
				)}
			</div>
			{error && <span className={styles.errorText}>{error}</span>}
			{warning && !error && (
				<span className={styles.warningText}>
					<InfoIcon className={styles.warningIcon} />
					{warning}
				</span>
			)}
		</div>
	);
};

export default Input;
